import { render, staticRenderFns } from "./BloodPressureMonitorReport.vue?vue&type=template&id=7870e805&scoped=true"
import script from "./BloodPressureMonitorReport.vue?vue&type=script&lang=js"
export * from "./BloodPressureMonitorReport.vue?vue&type=script&lang=js"
import style0 from "./BloodPressureMonitorReport.vue?vue&type=style&index=0&id=7870e805&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7870e805",
  null
  
)

export default component.exports